import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  KeycloakUsername,
  KeycloakToken,
  KeycloakUser,
  KeycloakNoUser,
} from '../models/database-models/';
import { environment } from 'src/environments/environment';
import { KeycloakADUser } from '../models/database-models/KeycloakADUser';
import { of } from 'rxjs/internal/observable/of';
@Injectable({
  providedIn: 'root',
})
export class KeycloakUserService {
  constructor(private httpClient: HttpClient) {}

  rootURL = environment.mpAPI.kc;
  keycloakRealmID = environment.kcRealmId;

  getNumberOfUsers(token: string) {
    let body = new URLSearchParams();
    body.set('token', token);

    let options = {
      headers: new HttpHeaders().set(
        'Content-Type',
        'application/x-www-form-urlencoded'
      ),
    };

    return this.httpClient.post<KeycloakNoUser>(
      this.rootURL + '/keycloak/getNumberOfUsers',
      body,
      options
    );
  }

  getAllKeycloakADUsers(){
    const options = {params: new HttpParams().set('realm_id', this.keycloakRealmID)};
    return this.httpClient.get<KeycloakADUser[]>(
      this.rootURL + '/keycloak/getAllADUsers', options
    );
  }

  getKeycloakUsers(token: string, offset: string) {
    let body = new URLSearchParams();
    body.set('token', token);
    body.set('offset', offset);

    let options = {
      headers: new HttpHeaders().set(
        'Content-Type',
        'application/x-www-form-urlencoded'
      ),
    };

    return this.httpClient.post<KeycloakUser[]>(
      this.rootURL + '/keycloak/getAllUsers',
      body,
      options
    );
  }

  getAdminToken() {
    let body = new URLSearchParams();
    body.set('username', 'admin');
    body.set('password', 'MPdsoP@ssw0rd!!!');
    //const headers = {"Content-Type":"application/x-www-form-urlencoded"};

    let options = {
      headers: new HttpHeaders().set(
        'Content-Type',
        'application/x-www-form-urlencoded'
      ),
    };
    return of('')
    /*return this.httpClient.post<KeycloakToken>(
      this.rootURL + '/keycloak/getToken',
      body,
      options
    );*/
  }

  getUserFullNameBy(userId: string, token: string) {
    let body = new URLSearchParams();
    body.set('token', token);
    body.set('username', userId);

    let options = {
      headers: new HttpHeaders().set(
        'Content-Type',
        'application/x-www-form-urlencoded'
      ),
    };

    return this.httpClient.post<KeycloakUsername>(
      this.rootURL + '/keycloak/getUsername',
      body,
      options
    );
  }
}
